
  import { mapGetters } from 'vuex';

  export default {
    middleware: ['pages/products/banking/mortgage/show', 'breadcrumbs', 'meta-tags'],
    meta: {
      category: 'banking',
      metaTagOptions: { image: 'mortgages' },
      product: 'mortgages'
    },
    computed: {
      ...mapGetters('products', { mortgage: 'get' }),
      ...mapGetters('search', { search: 'get' })
    }
  };
